var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _path11, _ellipse2, _path12, _path13, _path14, _path15, _polyline, _line, _line2, _path16, _line3, _path17, _line4, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd4b2",
    d: "M38.351,62.447l-2.507,8.081c7.176,6.856,15.142,6.998,23.976-0.225l-3.658-8.464L38.351,62.447z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0decf",
    d: "M61.805,75.476c-2.353,3.534-7.989,6.022-14.566,6.022c-5.896,0-11.035-2-13.731-4.959l1.391-6.009 c2.883,3.26,7.339,5.351,12.34,5.351c5.322,0,10.027-2.368,12.875-5.993L61.805,75.476z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd4b2",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.867,38.329c-1.049-0.297-2.254-0.324-3.106,0.453c-0.677,0.617-0.98,1.56-1.105,2.44c-0.207,1.45,0.121,2.94,0.735,4.255 c0.662,1.418,1.674,2.482,2.774,3.569c0.568,0.561,1.136,1.123,1.704,1.684"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd4b2",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M64.799,38.329c1.049-0.297,2.254-0.324,3.106,0.453c0.677,0.617,0.98,1.56,1.105,2.44c0.207,1.45-0.121,2.94-0.735,4.255 c-0.662,1.418-1.674,2.482-2.774,3.569c-0.568,0.561-1.136,1.123-1.704,1.684"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0decf",
    d: "M37.597,62.428l-5.11,16.493c-1.071,3.455-5.172,4.908-8.174,2.89 c-5.428-3.648-8.708-6.098-11.126-8.871c0.676-2.885,2.118-4.688,5.454-4.958l0.782-0.892c0.721-0.822,1.808-1.226,2.891-1.076 l0.578,0.08c1.829-3.021,5.589-4.628,9.549-4.015c0.232-1.064,0.952-1.825,2.099-2.678"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd4b2",
    stroke: "#1f212b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M47.242,17.269 c-9.342,0-16.915,7.692-16.915,17.18v11.403c0,9.126,6.072,17.138,14.858,19.605c1.15,0.323,2.365,0.328,3.518,0.016l0.418-0.113 c8.875-2.405,15.037-10.46,15.037-19.655V34.449C64.157,24.961,56.584,17.269,47.242,17.269z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M37.597,62.428l-5.11,16.493c-1.071,3.455-5.172,4.908-8.174,2.89c-5.428-3.648-8.708-6.098-11.126-8.871 c0.676-2.885,2.118-4.688,5.454-4.958l0.782-0.892c0.721-0.822,1.808-1.226,2.891-1.076l0.578,0.08 c1.829-3.021,5.589-4.628,9.549-4.015c0.232-1.064,0.952-1.825,2.099-2.678"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.641,
    cy: 75.881,
    fill: "#444445",
    stroke: "#1f212b",
    strokeMiterlimit: 10,
    rx: 3.516,
    ry: 3.009
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M32.793,65.276 c-1.874,1.862-2.189,6.386-2.637,10.682"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0decf",
    d: "M57.155,61.982l5.891,16.108c1.403,3.814,6.053,5.234,9.351,2.858 c2.877-2.073,5.985-4.213,7.678-5.067c2.434-1.228,6.738-0.575,6.738-0.575c-2.583-2.989-5.413-5.048-8.587-5.815 c-2.193-2.624-4.877-4.285-8.181-4.733c-1.837-1.922-3.935-3.179-6.423-3.448c-0.209-1.538-1.063-2.743-2.496-3.649"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M19.001,70.303 c3.009,2.3,3.409,4.423,4.32,6.569"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M57.155,61.982l5.891,16.108c1.403,3.814,6.053,5.234,9.351,2.858c2.877-2.073,5.985-4.213,7.678-5.067 c2.434-1.228,6.738-0.575,6.738-0.575c-2.583-2.989-5.413-5.048-8.587-5.815c-2.193-2.624-4.877-4.285-8.181-4.733 c-1.837-1.922-3.935-3.179-6.423-3.448c-0.209-1.538-1.063-2.743-2.496-3.649"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.567,
    cy: 75.475,
    fill: "#444445",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    rx: 3.211,
    ry: 3.617,
    transform: "rotate(-15.856 69.58 75.488)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M63.681,64.518 c0.181,4.484,1.594,7.776,2.855,12.02"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M69.213,65.276 c-0.347,2.682-0.255,4.481,0,5.951"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M61.805,75.476 c-2.353,3.534-7.989,6.022-14.566,6.022c-5.896,0-11.035-2-13.731-4.959"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M60.115,69.888 c-2.849,3.625-7.554,5.993-12.875,5.993c-5.001,0-9.457-2.091-12.34-5.351"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "45.993,40.957 45.993,52.094 46.863,52.618"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 34.444,
    x2: 43.593,
    y1: 35.597,
    y2: 34.875,
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 60.035,
    x2: 50.885,
    y1: 35.597,
    y2: 34.875,
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefdef",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M43.247,40.414 c0,1.572-1.952,3.228-4.361,3.228s-4.361-1.555-4.361-3.228c0-0.887,1.952-1.606,4.361-1.606S43.247,39.527,43.247,40.414z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 39.309,
    x2: 39.309,
    y1: 40.667,
    y2: 40.887,
    fill: "#fefdef",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefdef",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M51.231,40.414 c0,1.572,1.952,3.228,4.361,3.228s4.361-1.555,4.361-3.228c0-0.887-1.952-1.606-4.361-1.606S51.231,39.527,51.231,40.414z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 55.17,
    x2: 55.17,
    y1: 40.667,
    y2: 40.887,
    fill: "#fefdef",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M45.993,57.998h0.966 c0.511,0,1.017,0.112,1.48,0.329l0.356,0.167"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnify);
export default __webpack_public_path__ + "static/media/anify.c107b8e5ee7fbb1f944f9317e1851fd3.svg";
export { ForwardRef as ReactComponent };